export const DateFormat = {
  ISO: 'yyyy-MM-dd',
  MY: 'MM.yyyy',
  DM: 'dd.MM',
  DMY: 'dd.MM.yyyy',
  /** Parsing will default to `DateFormat.DMY` */
  DATE_HM: 'dd.MM.yyyy HH:mm',
  DATETIME: 'dd.MM.yyyy HH:mm:ss.SSS',
  /** Parsing will default to `DateFormat.ISO` */
  DATETIME_ISO: 'yyyy-MM-dd HH:mm:ss.SSS',
  /** To be used for formatting only. Won't work for parsing */
  LONG_MY: 'MMMM yyyy',
  /** Day of the week, month, year */
  LONG_W_DATE: 'EEEE, dd.MM.yyyy',
  /** Month, day, year in a text, i.e. February 17, 2025 */
  LONG_MDY: 'MMMM dd, yyyy',
  /** Day of the week, month, year in a text, i.e. Monday, February 17, 2025 */
  LONG_WMDY: 'EEEE, MMMM dd, yyyy',
  /** Day of the week, month, year in a text, i.e. Mon, Feb 17, 2025 */
  SHORT_WMDY: 'EEE, MMM dd, yyyy',
  TIME_LONG_WDMY: 'HH:mm EEEE, MMMM dd, yyyy',
  /** Full month, i.e. September */
  LONG_M: 'MMMM',
  /** Abbreviated month, i.e. Sep */
  SHORT_M: 'MMM',
  SHORT_MD: 'MMM dd',
  SHORT_MDY: 'MMM dd, yyyy',
  /** Day of the week, i.e. Mon */
  SHORT_W: 'EEE',
  /** Day of the week (long), i.e. Monday */
  LONG_W: 'EEEE',

  HM: 'HH:mm',
} as const;

type Formats = typeof DateFormat;
type DateKey = keyof Formats;

export type DateFormat = Formats[DateKey];
